import {StripeConnectSetup} from './onboarding/StripeConnectSetup';
import {CollectShippingAddress} from './onboarding/CollectShippingAddress';

import {db, getCurrentUserId, Timestamp} from '../firebase';
import { OnboardingStepsComplete } from './onboarding/OnboardingStepsComplete';
import {track as analytics_track} from '../analytics';
import { TermsAndConditionsStep } from './onboarding/TermsAndConditionsStep';

const saveStreetTeamOnboardingStep = async(stepName, stepData) => {
  const userId = getCurrentUserId();

  const stepDataWithTimeStamps = Object.assign({
    createdAt: Timestamp.now(),
    modifiedAt: Timestamp.now(),
    stepName,
  }, {stepData}, {userId});

  analytics_track('street_team.onboarding_step_complete', {
    stepName,
    stepData,
  })

  await db.collection('users').doc(userId).set({
    streetTeamOnboardingStarted: true,
  }, {merge: true});

  return await db
    .collection('streetTeamOnboardingSteps')
    .add(stepDataWithTimeStamps);
}

const ONBOARDING_STEP_INFOS = [
  {
    name: 'Terms and Conditions',
    slug: 'terms',
    component: TermsAndConditionsStep,
  }, {
    name: 'Get Paid',
    slug: 'get-paid',
    component: StripeConnectSetup
  }, {
    name: 'Shipping Address',
    slug: 'shipping-address',
    component: CollectShippingAddress
  }, {
    name: 'Onboarding Complete',
    slug: 'onboarding-complete',
    component: OnboardingStepsComplete,
  },
];

export {ONBOARDING_STEP_INFOS, saveStreetTeamOnboardingStep};



// WEBPACK FOOTER //
// ./src/street-team/OnboardingSteps.js